import { AuthEntrancePage } from "./AuthEntrancePage.page";

export function SignInPage() {
  return <AuthEntrancePage page="signIn"/>
}